import { observer } from 'mobx-react';
import { FC, ReactElement, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import IntegrationItem from './components/IntegrationItem/IntegrationItem';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { SCREENS } from 'src/constants/screens';
import theme from 'src/constants/styles';
import { localeStore } from 'src/mobx/localesStore';
import Headers from 'src/view/containers/Headers/Headers';
import HeaderBack from 'src/view/containers/Headers/components/HeaderBack/HeaderBack';
import integrationsStore from 'src/view/screens/SettingsScreen/store/integrationsStore';
import { Integrations } from '~/constants/integrations';
import { emptyArray } from '~/utils/helpers';
import ScrollableBlock from '~/view/containers/ScrollableBlock/ScrollableBlock';
import './style.scss';

const IntegrationsListScreen: FC = observer((): ReactElement => {
  useEffect(() => {
    integrationsStore.getIntegrations();
  }, []);

  return (
    <div className="d-flex flex-column full-width">
      <Headers>
        <HeaderBack title="Integrations" path={SCREENS.SETTINGS()} />
      </Headers>

      <ScrollableBlock showScrollbar scrollClassName="integrations_list__wrapper pr-5 mt-6">
        {integrationsStore.isLoading && integrationsStore.initial ? (
          emptyArray(3).map((_, index) => <Skeleton key={index} height={100} width={531} style={{ borderRadius: 26 }} />)
        ) : (
          <>
            {integrationsStore.integrationsState[Integrations.FOODICS] ? (
              <IntegrationItem
                key="foodics-integration-item"
                title={localeStore.t('t2_foodics')}
                description={localeStore.t('t2_integration_page_f5')}
                icon={Icons.Foodics}
                iconColor={theme.colors.white}
                iconBackgroundColor="#5830C5"
                path={SCREENS.SETTINGS_INTEGRATION(Integrations.FOODICS)}
              />
            ) : null}
            {integrationsStore.integrationsState[Integrations.GOOGLE_TAG_MANAGER] ? (
              <IntegrationItem
                key="google-tag-integration-item"
                path={SCREENS.SETTINGS_INTEGRATION(Integrations.GOOGLE_TAG_MANAGER)}
                title={localeStore.t('google_tag_manager')}
                description={localeStore.t('control_google_tag')}
                image="google_tag_manager.svg"
              />
            ) : null}

            {integrationsStore.integrationsState[Integrations.TAKER_GO] ? (
              <IntegrationItem
                key="taker-go-integration-item"
                path={SCREENS.SETTINGS_INTEGRATION(Integrations.TAKER_GO)}
                title={localeStore.t('taker-go')}
                description={localeStore.t('control_takergo')}
                icon={Icons.TakerGo}
                iconColor={theme.colors.dark}
              />
            ) : null}

            {integrationsStore.integrationsState[Integrations.GOOGLE_MAPS] ? (
              <IntegrationItem
                key="google-maps-integration-item"
                path={SCREENS.SETTINGS_INTEGRATION(Integrations.GOOGLE_MAPS)}
                title={localeStore.t('google-maps')}
                description={localeStore.t('control_google_maps')}
                image="google_maps.svg"
              />
            ) : null}

            {integrationsStore.integrationsState[Integrations.CHECKOUT] ? (
              <IntegrationItem
                key="checkout-integration-item"
                path={SCREENS.SETTINGS_INTEGRATION(Integrations.CHECKOUT)}
                title={localeStore.t('payment-checkout')}
                description={localeStore.t('control_payment-checkout')}
                icon={Icons.Checkout}
                iconColor={theme.colors.green}
              />
            ) : null}

            {integrationsStore.integrationsState[Integrations.CONNECT] ? (
              <IntegrationItem
                key="taker-connect-integration-item"
                path={SCREENS.SETTINGS_INTEGRATION(Integrations.CONNECT)}
                title={localeStore.t('taker_connect')}
                description={localeStore.t('control_taker_connect')}
                icon={Icons.TakerConnect}
                iconColor={theme.colors.dark}
              />
            ) : null}

            {integrationsStore.integrationsState[Integrations.APPLE_PAY] ? (
              <IntegrationItem
                key="taker-apple-pay-integration-item"
                path={SCREENS.SETTINGS_INTEGRATION(Integrations.APPLE_PAY)}
                title={localeStore.t('apple_pay')}
                description={localeStore.t('apple_pay_description')}
                icon={Icons.ApplePay}
                iconColor={theme.colors.dark}
                isHidden={true}
              />
            ) : null}

            {integrationsStore.integrationsState[Integrations.T360] ? (
              <IntegrationItem
                key="taker-t360-integration-item"
                path={SCREENS.SETTINGS_INTEGRATION(Integrations.T360)}
                title={localeStore.t('taker360')}
                description={localeStore.t('t360_desc')}
                image="taker360.svg"
                imageClassName="integration_item__t360_image"
              />
            ) : null}
          </>
        )}
      </ScrollableBlock>
    </div>
  );
});

export default IntegrationsListScreen;
